import { __classPrivateFieldGet } from 'tslib';
import * as i0 from '@angular/core';
import { Component, ViewChild, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { FormControl, Validators, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@pv-frontend/pv-shared-components/divider';
import { PvDividerModule } from '@pv-frontend/pv-shared-components/divider';

var _MobileInput_instances, _MobileInput_updateWiredValue;
class MobileInput {
    constructor() {
        _MobileInput_instances.add(this);
        this._input = new FormControl('', Validators.required);
        this.label = '';
        this.autoFocus = false;
        this.style = {};
        /**
         * Explicitly send this flag when backend sends some erroneous response for passed mobile number
         */
        this.isInvalid = false;
        /**
         * Error message to be shown below the mobile number input
         */
        this.errorMessage = '';
        // TODO - add logic to integrate the countries service and fetch all the calling codes
        // This will be done later
        this.callingCode = '91';
        this.minLength = 10;
        this.maxLength = 10;
    }
    ngAfterViewInit() {
        if (this.autoFocus) {
            this.inputEl.nativeElement.focus();
        }
    }
    handleInput(event) {
        __classPrivateFieldGet(this, _MobileInput_instances, "m", _MobileInput_updateWiredValue).call(this, event.target.value);
    }
    handleKeyDown(event) {
        // allow whitelisted keys like tab, backspace, enter and delete
        if (['Tab', 'Backspace', 'Delete', 'Enter'].includes(event.key)) {
            return;
        }
        // Safari fires Cmd + V through keyPress event as well
        // So we need to handle it here and let it through, this is then handled by the paste handler
        if (event.key === 'v' && event.metaKey) {
            return;
        }
        const isDigit = /\d/.test(event.key);
        // if the user has already entered max allowable digits, do not change input on further changes
        if (isDigit &&
            event.target.value.length >= this.maxLength) {
            event.preventDefault();
        }
        // return if a non-numeric and unallowed character is pressed
        if (!isDigit) {
            event.preventDefault();
            return;
        }
    }
    handlePaste(event) {
        event.preventDefault();
        const pasteData = event.clipboardData?.getData('text');
        // test that the pasted number should have min and max length as defined
        const allowedNumberRegex = new RegExp(`^\\d{${this.minLength},${this.maxLength}}$`);
        if (pasteData && allowedNumberRegex.test(pasteData)) {
            this._input.setValue(pasteData);
            // this.inputEl.nativeElement.value = pasteData;
            __classPrivateFieldGet(this, _MobileInput_instances, "m", _MobileInput_updateWiredValue).call(this, pasteData);
            this.onTouched?.();
        }
        else {
            console.error('pasted number is invalid ', pasteData);
        }
    }
    writeValue(obj) {
        this._input.setValue(obj?.number);
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        if (isDisabled) {
            this._input.disable();
        }
        else {
            this._input.enable();
        }
    }
}
_MobileInput_instances = new WeakSet(), _MobileInput_updateWiredValue = function _MobileInput_updateWiredValue(value) {
    this.onChange?.({
        number: value,
        callingCode: this.callingCode,
        // default country ID for India
        // TODO - This will be fixed when support for multiple countries is built
        countryId: 'efb468c6-2d84-4caa-a826-ff0ab253d0c6',
    });
};
MobileInput.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MobileInput, deps: [], target: i0.ɵɵFactoryTarget.Component });
MobileInput.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.9", type: MobileInput, selector: "pv-mobile-input", inputs: { label: "label", autoFocus: "autoFocus", style: "style", isInvalid: "isInvalid", errorMessage: "errorMessage" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: MobileInput,
            multi: true,
        },
    ], viewQueries: [{ propertyName: "inputEl", first: true, predicate: ["pvOtpInputEl"], descendants: true }], ngImport: i0, template: "<div\n  class=\"pv-mobile-input-container flex flex-column w-25rem\"\n  [style]=\"this.style?.container\">\n  <label\n    *ngIf=\"this.label\"\n    class=\"pv-mobile-input-label mb-3 surface-text-subtle-low-contrast text-sm\"\n    [style]=\"this.style?.label\">\n    {{ this.label }}\n  </label>\n  <div\n    class=\"pv-mobile-input-box surface-action-icon-low-contrast pv-border-solid p-1 border-round-xs flex flex-row align-items-center text-sm bg-white\"\n    [class.is-invalid-mobile]=\"this.isInvalid\"\n    [style]=\"this.style?.inputBox\">\n    <span class=\"pv-mobile-input-box-calling-code pl-2\">\n      +{{ this.callingCode }}\n    </span>\n    <pv-divider\n      [layout]=\"'vertical'\"\n      class=\"surface-border-normal pt-1 pb-1 ml-2 mr-2\"></pv-divider>\n    <input\n      #pvOtpInputEl\n      [formControl]=\"_input\"\n      pInput\n      class=\"pv-mobile-input-ele w-full h-full text-sm bg-transparent p-0\"\n      placeholder=\"Enter 10-digit number\"\n      type=\"tel\"\n      autocomplete=\"on\"\n      (input)=\"this.handleInput($event)\"\n      (keydown)=\"this.handleKeyDown($event)\"\n      (paste)=\"this.handlePaste($event)\"\n      [style]=\"this.style?.input\" />\n  </div>\n  <span\n    *ngIf=\"this.isInvalid && this.errorMessage\"\n    class=\"pv-invalid-mobile-label feedback-text-negative w-max text-sm mt-2\"\n    [style]=\"this.style?.error\">\n    {{ this.errorMessage }}\n  </span>\n</div>\n", styles: [".pv-mobile-input-container>.pv-mobile-input-box{min-height:2.5rem}.pv-mobile-input-container>.pv-mobile-input-box.is-invalid-mobile{border-color:var(--feedback-background-negative-high-contrast)!important;outline-color:var(--feedback-background-negative-high-contrast)!important}.pv-mobile-input-container>.pv-mobile-input-box>.pv-mobile-input-ele{outline:none;border:none;font-family:inherit}.pv-mobile-input-container>.pv-mobile-input-box>.pv-mobile-input-ele::placeholder{color:var(--surface-text-placeholder-low-contrast)}.pv-mobile-input-container>.pv-mobile-input-box:has(.pv-mobile-input-ele:focus){border-color:var(--primary-color);outline:var(--primary-color)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.DividerComponent, selector: "pv-divider", inputs: ["style", "styleClass", "layout"] }, { kind: "directive", type: i3.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i3.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i3.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: MobileInput, decorators: [{
            type: Component,
            args: [{ selector: 'pv-mobile-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: MobileInput,
                            multi: true,
                        },
                    ], template: "<div\n  class=\"pv-mobile-input-container flex flex-column w-25rem\"\n  [style]=\"this.style?.container\">\n  <label\n    *ngIf=\"this.label\"\n    class=\"pv-mobile-input-label mb-3 surface-text-subtle-low-contrast text-sm\"\n    [style]=\"this.style?.label\">\n    {{ this.label }}\n  </label>\n  <div\n    class=\"pv-mobile-input-box surface-action-icon-low-contrast pv-border-solid p-1 border-round-xs flex flex-row align-items-center text-sm bg-white\"\n    [class.is-invalid-mobile]=\"this.isInvalid\"\n    [style]=\"this.style?.inputBox\">\n    <span class=\"pv-mobile-input-box-calling-code pl-2\">\n      +{{ this.callingCode }}\n    </span>\n    <pv-divider\n      [layout]=\"'vertical'\"\n      class=\"surface-border-normal pt-1 pb-1 ml-2 mr-2\"></pv-divider>\n    <input\n      #pvOtpInputEl\n      [formControl]=\"_input\"\n      pInput\n      class=\"pv-mobile-input-ele w-full h-full text-sm bg-transparent p-0\"\n      placeholder=\"Enter 10-digit number\"\n      type=\"tel\"\n      autocomplete=\"on\"\n      (input)=\"this.handleInput($event)\"\n      (keydown)=\"this.handleKeyDown($event)\"\n      (paste)=\"this.handlePaste($event)\"\n      [style]=\"this.style?.input\" />\n  </div>\n  <span\n    *ngIf=\"this.isInvalid && this.errorMessage\"\n    class=\"pv-invalid-mobile-label feedback-text-negative w-max text-sm mt-2\"\n    [style]=\"this.style?.error\">\n    {{ this.errorMessage }}\n  </span>\n</div>\n", styles: [".pv-mobile-input-container>.pv-mobile-input-box{min-height:2.5rem}.pv-mobile-input-container>.pv-mobile-input-box.is-invalid-mobile{border-color:var(--feedback-background-negative-high-contrast)!important;outline-color:var(--feedback-background-negative-high-contrast)!important}.pv-mobile-input-container>.pv-mobile-input-box>.pv-mobile-input-ele{outline:none;border:none;font-family:inherit}.pv-mobile-input-container>.pv-mobile-input-box>.pv-mobile-input-ele::placeholder{color:var(--surface-text-placeholder-low-contrast)}.pv-mobile-input-container>.pv-mobile-input-box:has(.pv-mobile-input-ele:focus){border-color:var(--primary-color);outline:var(--primary-color)}\n"] }]
        }], propDecorators: { inputEl: [{
                type: ViewChild,
                args: ['pvOtpInputEl']
            }], label: [{
                type: Input
            }], autoFocus: [{
                type: Input
            }], style: [{
                type: Input
            }], isInvalid: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }] } });

class PvMobileInputModule {
}
PvMobileInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvMobileInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PvMobileInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.9", ngImport: i0, type: PvMobileInputModule, declarations: [MobileInput], imports: [CommonModule, PvDividerModule, ReactiveFormsModule], exports: [MobileInput] });
PvMobileInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvMobileInputModule, imports: [CommonModule, PvDividerModule, ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.9", ngImport: i0, type: PvMobileInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, PvDividerModule, ReactiveFormsModule],
                    declarations: [MobileInput],
                    exports: [MobileInput],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { MobileInput, PvMobileInputModule };
